import styled from "styled-components";

export const ShumokuManagementMainStyled = styled.div`
  flex: 1;
`;
